export default __webpack_public_path__ + "static/media/032-hill.5aacf3b4.png";